if (!customElements.get('mobile-collapse')) {
  customElements.define('mobile-collapse', class MobileCollapse extends HTMLElement {
    constructor() {
      super();
      const expandButton = this.parentElement.querySelector('.expand-button');
      expandButton.addEventListener('click', this.toggleExpand.bind(this, true));
      const collapseButton = this.parentElement.querySelector('.collapse-button');
      collapseButton.addEventListener('click', this.toggleExpand.bind(this, false));
    }

    toggleExpand(expand) {
      if (expand) {
        this.classList.add('expanded');
      } else {
        this.classList.remove('expanded');
      }
    }
  });
}
